import React, { useEffect, useState } from 'react';
import BoardFloatPrompt from './BoardFloatPrompt';
import './FloatActionBar.scss';

interface Props {
  sentinelRef: React.RefObject<HTMLDivElement>;
  isDonee: boolean;
}

const FloatActionBar: React.FC<Props> = ({ sentinelRef, isDonee }) => {
  const [ visible, setVisible ] = useState(false);

  useEffect(() => {
    const sentinel = sentinelRef.current;
    if (!sentinel) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const pastSentinel = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        setVisible(pastSentinel);
      });
    }, { threshold: 0 });

    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [ sentinelRef ]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div
      className={ `float-action-bar${ visible ? ' float-action-bar--shown' : '' }` }
      aria-hidden={ !visible }
    >
      { isDonee && <BoardFloatPrompt /> }
      <button
        type="button"
        className="float-action-bar__totop"
        onClick={ scrollToTop }
        tabIndex={ visible ? 0 : -1 }
        aria-label="トップに戻る"
      >
        <span className="float-action-bar__totop-icon" aria-hidden="true">↑</span>
      </button>
    </div>
  );
};

export default FloatActionBar;
